import { parametersServices } from "../../../services";

export async function ChannelTypes() {
	const channelTypes = await parametersServices.getChannelTypes();

	const columns = [
		{
			key: "id",
			name: "#",
			sort: 0,
			type: "id",
		},
		{
			key: "value",
			name: "static-parameters.title",
			sort: 1,
			type: "title",
		},
		{
			key: "key",
			name: "static-parameters.key",
			sort: 2,
			type: "title",
		},
	];
	const rows = [];

	await channelTypes.payload?.map((channelType, key) => {
		rows.push({
			id: key + 1,
			value: channelType.value,
			key: channelType.key,
		});
	});
	const tableData = {
		columns: columns,
		rows: rows,
	};
	return tableData;
}
